<template>
  <div class="actions-menu-wrapper">
    <div class="message-bar actions">
      <li v-if="!inbox"><a @click="toggleReply" href="#" v-b-tooltip.hover.bottom title="Reply"><span><fa icon="reply"/></span></a></li>
      <li v-if="!inbox"><a @click="forwardMessage" href="#" v-b-tooltip.hover.bottom title="Forward"><span><fa icon="angle-double-right"/></span></a></li>
      <li v-if="!inbox"><a @click="toggleNote" href="#" v-b-tooltip.hover.bottom title="Add Note"><span><fa icon="pen"/></span></a></li>
      <li>
        <b-dd id="assign-dd" no-caret>
          <template slot="button-content">
            <a href="#" v-b-tooltip.hover.bottom title="Assign">
              <span>
                <fa icon="user-plus"/>
              </span>
            </a>
          </template>
          <b-dropdown-item disabled>
            <SingleUserSelector v-if="!inbox" v-on:user-change="user = $event" v-on:user-remove="user = {id: null}" :parent="message" :parentPath="'message'"/>
            <SingleUserSelector v-else v-on:user-change="user = $event" v-on:user-remove="user = {id: null}" :parent="user" :parentPath="'message'"/>
          </b-dropdown-item>
        </b-dd>
      </li>
      <li>
        <b-dd id="status-dd" no-caret>
          <template slot="button-content">
            <a href="#" v-b-tooltip.hover.bottom title="Change status">
              <span>
                <fa icon="flag"/>
              </span>
            </a>
          </template>
          <b-dropdown-item disabled>
            <v-select v-model="status" :options="statuses" />
          </b-dropdown-item>
        </b-dd>
      </li>
      <li>
        <b-dd id="move-dd" no-caret>
          <template slot="button-content">
            <a href="#" v-b-tooltip.hover.bottom title="Move">
              <span>
                <fa icon="external-link-alt"/>
              </span>
            </a>
          </template>
          <b-dropdown-item disabled>
            <v-select v-model="mailbox" :options="mailboxesCollection" />
          </b-dropdown-item>
        </b-dd>
      </li>
      <li><a v-b-tooltip.hover.bottom title="Delete" @click="status = 'closed'" href="#"><span><fa icon="trash"/></span></a></li>
      <li v-if="!hasTicket"><a @click="showNewTicketModal(message)" href="#" v-b-tooltip.hover.bottom title="Create Ticket"><span><fa icon="plus-circle"/></span></a></li>
      <li>
        <b-dd id="tags-dd" no-caret>
          <template slot="button-content">
            <a href="#" v-b-tooltip.hover.bottom title="Tag">
              <span>
                <fa icon="tags"/>
              </span>
            </a>
          </template>
          <b-dropdown-item disabled class="inline-dropdown">
            <v-select multiple v-model="tagList" :options="tagsCollection" class="tag-select"/>
            <b-btn variant="info" class="tag-submit" @click="updateTagList()">Submit</b-btn>
          </b-dropdown-item>
        </b-dd>
      </li>
      <li v-if="messageIds.length > 1"><a @click="mergeMessages()" href="#" v-b-tooltip.hover.bottom title="Merge"><span><fa icon="layer-group"/></span></a></li>
      <li v-if="message && message.merged">
        <b-dd id="merged-dd" no-caret>
          <template slot="button-content">
            <a class='merged' href="#" v-b-tooltip.hover.bottom title="Merged Message">({{message.merged_with.total}})<span><fa icon="layer-group"/></span></a>
          </template>
          <b-dropdown-item @click="splitMessages()">
            Split
          </b-dropdown-item>
        </b-dd>
      </li>
      <li class="float-right" v-if="message && message.previous_message" v-b-tooltip.hover.bottom title="Older">
        <router-link :to="{name: 'Message', params: { id: message.previous_message } }"><span><fa icon="chevron-down"/></span></router-link>
      </li>
      <li class="float-right" v-if="message && message.next_message" v-b-tooltip.hover.bottom title="Newer">
        <router-link :to="{name: 'Message', params: { id: message.next_message } }"><span><fa icon="chevron-up"/></span></router-link>
      </li>
      <li class="float-right li-avatars" v-if="message && (message.message_state.viewers || message.message_state.editors)">
        <transition-group name="fade">
          <img v-for="(replier, key, i) in message.message_state.editors"
               :key="'avatar-reply'+replier.user_id"
               v-if="(replier.user_id !== currentUser.id) && (i < 10)"
               :src="replier.avatar_url"
               class="user-avatar replying"
               v-b-tooltip.hover.bottom
               :title="replier.name">
          <img v-for="(viewer, key, i) in message.message_state.viewers"
               :key="'avatar-view'+viewer.user_id"
               v-if="showViewerAvatar(viewer.user_id, i)"
               :src="viewer.avatar_url"
               class="user-avatar viewing"
               v-b-tooltip.hover.bottom
               :title="viewer.name">
        </transition-group>
      </li>
    </div>
    <b-alert id="messageActionsAlert" v-model="showDismissibleAlert" variant="danger" dismissible>
      <span v-html="flashError"></span>
    </b-alert>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
export default {
  name: 'MessageActions',
  props: {
    inbox: Boolean,
    messageIds: Array,
    hasTicket: Boolean,
    mailboxId: Number,
    message: {
      type: Object
    }
  },
  components: {
    SingleUserSelector
  },
  data () {
    return {
      user: {},
      mailbox: null,
      status: null,
      statuses: ['active', 'pending', 'closed'],
      tagList: [],
      showDismissibleAlert: false,
      flashError: ''
    }
  },
  mounted () {
    this.loadTagList()
  },
  computed: {
    ...mapGetters(['currentUser', 'tagsCollection', 'mailboxesCollection', 'currentInbox'])
  },
  methods: {
    ...mapMutations(['setDefaultDraft']),
    loadTagList () {
      if (this.message) {
        this.tagList = this.message.tags.map(function (tag) {
          return {label: tag.name, value: tag.name, color: tag.color}
        })
      }
    },
    toggleNote () {
      this.scrollTop()
      this.$root.$emit('toggleNote')
    },

    forwardMessage () {
      this.$store.commit('setForwardedMessage', true)
      this.$root.$emit('composeMessage', this.currentInbox)
    },

    toggleReply () {
      this.scrollTop()
      this.setDefaultDraft()
      this.$store.commit('setForwardedMessage', false)
      this.$root.$emit('toggleReply')
    },

    submitChanges (params) {
      var vm = this
      if (this.inbox) {
        this.$parent.loadingChanges = true
      }
      params.ids = this.messageIds
      this.$http.put('/messages_bulk_update', params)
        .then(function (response) {
          if (params.user_id === null) {
            vm.tagList = false
            vm.$router.push('/inboxes/' + vm.mailboxId)
          } else {
            vm.submitComplete()
          }
        })
        .catch(e => {
          console.log(e)
          let errorMessage = ''
          if (e.response.data) {
            e.response.data.forEach(d => {
              errorMessage += `${Object.values(d)[0]} <br/>`
            })
            this.flashError = errorMessage
            this.showDismissibleAlert = true
            if (this.inbox) {
              this.$parent.loadingChanges = false
            }
          }
        })
    },
    mergeMessages () {
      var vm = this
      this.$http.post('/merge_messages', {ids: vm.messageIds})
        .then(function (response) {
          vm.$router.push('/messages/' + response.data.message_id)
        })
        .catch(e => { console.log(e) })
    },

    submitComplete () {
      if (this.inbox) {
        this.$root.$emit('bulkMessageChangeSubmitted')
      } else {
        this.$store.dispatch('reloadMessage')
        if (this.status === 'closed') {
          this.submitRedirect()
        }
      }
      this.resetFields()
      this.loadTagList()
    },

    submitRedirect () {
      switch (this.currentUser.message_redirect) {
        case 1:
          this.$router.push('/inboxes/' + this.mailboxId + '?q=mine')
          break
        case 2:
          this.$router.go(-2)
          break
        default:
          this.$router.push('/inboxes/' + this.mailboxId)
      }
    },
    resetFields () {
      this.mailbox = null
      this.status = null
      this.tagList = []
    },
    scrollTop () {
      document.getElementById('vue-navcontent').scrollTo(0, 0)
    },

    showViewerAvatar (id, i) {
      var draftIds = Object.keys(this.message.message_state.editors).map(id => parseInt(id))
      if (draftIds.includes(id)) {
        return false
      } else if ((id !== this.currentUser.id) && i < 3) {
        return true
      }
    },

    showNewTicketModal (message) {
      var ticket = { message: message, review_request: 'unrequested' }
      this.$root.$emit('ticketEdit', ticket)
    },
    splitMessages () {
      var vm = this
      this.$http.post('/split_message', {id: vm.message.id})
        .then(function (response) {
          vm.$router.push('/inboxes/' + vm.message.mailbox.id)
        })
        .catch(e => { console.log(e) })
    },
    updateTagList () {
      if (!this.message) {
        this.submitChanges({ tag_list: this.tagList.map(function (tag) { return tag.value || tag }) })
      } else if (this.tagList !== null) {
        this.submitChanges({ tag_list: this.tagList.map(function (tag) { return tag.value || tag }) })
      }
    }
  },
  watch: {
    user () {
      if (this.user.id) {
        this.submitChanges({ user_id: this.user.id })
      } else {
        if (!this.inbox) {
          this.submitChanges({ user_id: null })
        }
      }
    },
    mailbox () {
      if (this.mailbox !== null) {
        this.submitChanges({ mailbox_id: this.mailbox.value })
      }
    },
    status () {
      if (this.status !== null) {
        this.submitChanges({ status: this.status })
      }
    },
    message () {
      this.loadTagList()
    }
  }
}
</script>

<style scoped>
  li {
    display: inline;
  }
  li > a {
    padding: 8px 15px 8px 0px;
  }
  li span {
    font-size: 24px;
    line-height: 41px;
    color: #fff;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  div.actions {
    display: inline;
    float: left;
    width: 100%;
    text-align: left;
  }
  .btn {
    padding: 0px;
  }
  .user-avatar {
    border-radius: 50%;
    height: 30px;
    width: 30px;
  }
  .user-avatar.viewing {
    border: 1px solid #F5B126;
  }
  .user-avatar.replying {
    border: 1px solid #E52F28;
  }
  .li-avatars {
    padding: 0px 15px 0px 0px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .35s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .fade-enter,
  .fade-leave {
    opacity: 0;
  }
  .inline-dropdown {
    display: inline-flex;
  }
  .tag-select {
    flex-grow: 3;
    margin-right: 5px;
  }
  .tag-submit {
    padding: 0px 5px;
  }
  @media (max-width: 399px) {
    .message-actions li.float-right {
      float: none !important;
    }
  }
</style>

<style>
.message-bar.actions > li > .btn-group.b-dropdown.dropdown > button.btn.btn-secondary {
  padding: 0px;
  border: none;
  background-color: inherit;
  color: inherit;
  line-height: 50px;
}
.message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a {
  padding: 8px 15px 8px 0px;
}
.message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a:link {
  color: #FFF;
}
.message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a:visited {
  color: #FFF;
}
.message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a.merged {
  padding: 0;
}
.message-bar.actions > li > .btn-group.b-dropdown.dropdown > .dropdown-menu {
  min-width: 20rem;
}
div.dropdown-toggle::after {
  display: none;
}
.merged {
  color: #fff;
}
.merged:hover {
  color: #fff;
}
#messageActionsAlert {
  position: fixed;
  top: 120px;
  right: 0;
}
@media (max-width: 767px) {
 .message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a {
   padding: 8px 8px 8px 0px;
 }
 .message-bar.actions > li > a {
   padding: 8px 8px 8px 0px;
 }
}

</style>



// WEBPACK FOOTER //
// src/components/MessageActions.vue